(function () {
  'use strict';

  angular
    .module('vcutils.vcshare')
    .config(config);
  
  config.$inject = ['$stateProvider', '$logProvider'];
  
  function config($stateProvider, $log) {
    $stateProvider
      .state('playground.vcutilsshare', {
        url: '/vcutilsshare',
        views: {
          'playgroundmain@playground': {
            template: `
              <h3 class="alert alert-info"><tt>&lt;sharesearch share="" shareref="" editinplace="true"&gt;</tt></h3><div ui-view="sharesearchview"></div>
              <h3 class="alert alert-info"><tt>&lt;sharesearch share="" shareref="" parentsave=""&gt;</tt></h3><div ui-view="sharesearchview2"></div>
              <h3 class="alert alert-info"><tt>&lt;shareeditor share="" mode="" onClose=""&gt;</tt></h3><div ui-view="shareeditview"></div>
              <h3 class="alert alert-info"><tt>&lt;sharenew&gt;</tt></h3><div ui-view="sharenewview"></div>
              <h3 class="alert alert-info"><tt>&lt;sharelist shares="?"&gt;</tt></h3><div ui-view="sharelistview"></div>
            `
          }
        },
        onEnter: function ($log) {
          $log.debug('debug/routes - playground.vcutilsvcshare entered');
        }
      });
    
    
    $stateProvider
      .state('playground.vcutilsshare.allcomponents', {
        url: '/allcomponents',
        resolve: {
          share: function () {
            return '';
          },
          shareref: function () {
            return '';
          },
          someshare: function (Share) {
            return Share.$find('572b31b07c01597e3e150923');
          },
          allshares: function (Share) {
            return Share.$search({active: true});
          },
          parentsavesearch: function () {
            return function (share, shareref) {
              console.log('debug: dummy parentsave called for sharesearch with: ', share, shareref);
            };
          },
          eip: function () {
            return true;
          }
        },
        views: {
          // When `fooState.barState` is active, `fooComponent`
          // is loaded into the <ui-view name='content' />
          // which was created by `fooState`.
          // The component's `foo` input receives `fooData` resolve
          'sharesearchview@playground.vcutilsshare': {
            component: 'sharesearch',
            bindings: {
              share: 'share',
              shareref: 'shareref',
              editinplace: 'eip'
            }
          },
          'sharesearchview2@playground.vcutilsshare': {
            component: 'sharesearch',
            bindings: {
              share: 'share',
              shareref: 'shareref',
              parentsave: 'parentsavesearch'
            }
          },
          'shareeditview@playground.vcutilsshare': {
            component: 'shareeditor',
            bindings: {
              share: 'someshare'
            }
          },
          'sharenewview@playground.vcutilsshare': {
            component: 'sharenew',
            bindings: {
            }
          },
          'sharelistview@playground.vcutilsshare': {
            component: 'sharelist',
            bindings: {
              shares: 'allshares'
            }
          }
        },
        onEnter: function () {
          console.log('playground.vcutilsshare.allcomponents entered');
        }
      });
    
    
  }// all routes
  
  
}());






